import { useContext, useEffect, useState } from "react";
import { getAllSubmittedForms } from "../../services/firebase/submittedForms/tb_submittedForms";
import { Link, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import FormContext from "../../context/form-context";
import initialState from "../../state/initialState";
import { resetFormState} from "../../state/action";
import useAuth from "../../hooks/useAuth";
import { ROLES } from "../../constants/roles";
import FieldInfo from "../../components/FieldInfo/FieldInfo";
import { Chip } from "@mui/material";
import { statusColor } from "../../utils/utilities";


const tbColumns = [
    { id: 'transcationID', label: 'Transaction ID', minWidth: 130, maxWidth: 150 },
    { id: 'form', label: 'Form', minWidth: 50 },
    { id: 'type', label: 'Type', minWidth: 50 },
    // { id: 'formName', label: 'Forms', minWidth: 50 },
    { id: 'propertyAddress', label: 'Property Address', minWidth: 130, maxWidth: 150 },
    { id: 'agent', label: 'Agent', minWidth: 50 },
    { id: 'created', label: 'Created Date', minWidth: 50 },
    { id: 'status', label: 'Status', minWidth: 20, maxWidth: 20 },
    { id: 'action', label: '', minWidth: 50 },
]


const useListPage = () => {
    const { dispatch} = useContext(FormContext)
    const { auth } = useAuth();
    const [tbItems , setTBItems] = useState([]);
    const [isLoad, setIsLoad] = useState(false);
    const [searchText, setSearchText] = useState('')
    const [filteredTbItems, setFilteredTbItems] = useState([])
    const [openModal, setOpenModal] = useState(false);
    const isHQ = auth?.role === ROLES.HQ;
    
    const navigate = useNavigate();
    
    useEffect(
        () => {
            const fetchAllForms = async (id , role) => {
                const data = await getAllSubmittedForms(id , role);
                const items = await createTableItemsData(data)
                setTBItems(items)
                setIsLoad(true)
            }

            fetchAllForms(auth.id, auth.role);
            dispatch(resetFormState())
        }, [])
    
    const createTableItemsData = (data) => {
        const tbItems = [];
        const sortedByDate = data.sort((a, b) => b.Created?.seconds - a.Created?.seconds)

        sortedByDate.forEach(item => {
            const forms = item.Values?.formValues;
            // const formName = item.SelectedTemplates || [];
            const propertyAddress = item.Values?.mainValues.propertyAddress || "";
            const createdBy = item.CreatedBy ?  item.CreatedBy.display_name  : "";
            const modifiedBy = item.ModifiedBy ?  item.ModifiedBy.display_name  : "";
            const agent = item.Agent ?  item.Agent.display_name  : "";
            const createdDate = item.Created ? dayjs(new Date(item.Created?.seconds * 1000)).format('MMMM DD, YYYY hh:mm A') : " ";
            const modifiedDate = item.Modified ? dayjs(new Date(item.Modified?.seconds * 1000)).format('MMMM DD, YYYY hh:mm A') : " ";
           
            tbItems.push(createTableData(
                item.TransactionId ?  <Link to={`/edit/${item.TransactionId}`}>{item.TransactionId}</Link> : item.TransactionId,
                item.Form,
                item.Type,
                // formName.toString(),
                propertyAddress,
                agent ? agent : createdBy,
                createdDate,
                item.Status ? <Chip sx={{ fontSize: 9,  backgroundColor: statusColor(item.Status) }} label={`${item.Status}`}/> : item.Status,
                <FieldInfo content={
                    `<b>Created:</b> ${createdDate} <br/>
                    <b>Created By:</b> ${createdBy} <br/>
                    <b>Last Modified:</b> ${modifiedDate} <br/>
                    <b>Last Modified By:</b> ${modifiedBy} 
                    `
                } />
            ))
        });
        
        return tbItems
    }

    const createTableData = (transcationID, form, type, propertyAddress, agent, created, status, action) => {
        return { transcationID, form, type,  propertyAddress, agent, created, status, action};
    }

    const searchFromTable = async (event) => {
        const value = event.target.value.toLowerCase();
        setIsLoad(false)
        setSearchText(value)
        
        if(value.trim()===''){
            await setFilteredTbItems(tbItems)
            setIsLoad(true)
        }
        if(value.length > 2){
           
            const filteredTBItems = tbItems.filter( item => 
                item.form?.toLowerCase().includes(value) || 
                item.type?.toLowerCase().includes(value) || 
                item.propertyAddress?.toLowerCase().includes(value) ||
                item.created?.toLowerCase().includes(value) || 
                item.agent?.toLowerCase().includes(value) ||
                item.status?.props?.label?.toString().toLowerCase().includes(value) || 
                item.transcationID.props?.children?.toString().toLowerCase().includes(value)
            ); 

            await setFilteredTbItems(filteredTBItems)
            setIsLoad(true)
        }
        
    }

    const btnAction ={
        handleCreate: () => {
            navigate('/create')
        },
        handleCreateForOthers: () => {
            setOpenModal(true)
        }
    }
   

    return {
        tbColumns,
        tbItems,
        isLoad,
        searchFromTable,
        btnAction,
        searchText,
        filteredTbItems,
        openModal,
        setOpenModal,
        isHQ
    }
    

}
export default useListPage;